import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Container, Row, Col, Card, CardBody, Button, Input } from "reactstrap"
import { FormikProvider, useFormik, Form, Field } from "formik"
import * as Yup from "yup"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Spin } from "antd"
import swal from "sweetalert"

import CustomInput from "Custom/CustomInput"
import SwalError from "Custom/SwalError"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import { post, get, postFormData } from "helpers/api_helper"
import {
  POST_CreatePOUploadVerification,
  GET_POUploadVerificationDetails,
  POST_UploadDocumnet,
  POST_POStoreFiles,
} from "helpers/url_helper"

const AddPOUploadVerification = props => {
  const navigate = useNavigate()
  const { token } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [showSwalError, setShowSwalError] = useState(false)
  const [swalErrorMsg, setSwalErrorMsg] = useState("")
  const [userId, setUserId] = useState(null)
  const [attachFileFields, setAttachFileFields] = useState([{ File: "" }])

  // Accessing company ID from Redux store
  const companyId = useSelector(state => state?.Login?.currentCompanyId)
  const AuthUser = JSON.parse(localStorage.getItem("authUser"))
  const userCompanyInfo = JSON.parse(localStorage.getItem("userCompanyInfo"))
  const Cid =
    AuthUser?.org === true ? userCompanyInfo?.organization?.id : companyId
  console.log(token, "token")
  useEffect(() => {
    if (token) {
      fetchDataByToken(token)
    }
  }, [token])

  const fetchDataByToken = async token => {
    setIsLoading(true)
    try {
      const response = await get(`${GET_POUploadVerificationDetails}/${token}`)
      if (response.status === 200) {
        const { first_name, email, phone, id } = response.data
        setUserId(id)
        formik.setValues({
          name: first_name,
          email,
          contactNumber: phone,
        })
      } else {
        swal({
          title: "Error!",
          text: response.message,
          icon: "error",
          button: "OK",
        })
      }
    } catch (error) {
      console.error("Error fetching details:", error)
      swal({
        title: "Error!",
        text: "An unexpected error occurred.",
        icon: "error",
        button: "OK",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      contactNumber: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is a required field."),
      email: Yup.string()
        .email("Invalid email format.")
        .required("Email is a required field."),
      contactNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits.")
        .required("Contact Number is a required field."),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (token) {
        await handleValidSubmit(values)
      } else {
        await handleSimpleSubmit(values, { resetForm })
      }
    },
  })

  const handleValidSubmit = async (values) => {
    setIsLoading(true);
  
    let AttachFileIDs = [];
  
    for (let index = 0; index < attachFileFields.length; index++) {
      const x = attachFileFields[index];
  
      if (x?.File) {
        let formData = new FormData();
        formData.append("module_slug", null);
        const label = index === 0 ? "Purchase Order" : `Purchase Order ${index + 1}`;
        formData.append("label", label);
        formData.append("file", x.File);
  
        try {
          // Call the API to upload the document
          const response = await postFormData(POST_UploadDocumnet, formData);
  
          // If the API call succeeds, store the file ID
          if (response?.status === 200) {
            AttachFileIDs.push(response?.data?.id);
          } else {
            // If there's an error, handle it and stop further processing
            if (typeof response?.message === "string") {
              swal({
                title: "Error!",
                text: response.message,
                icon: "error",
                button: "OK",
              });
              return; // Stop further processing
            } else {
              setSwalErrorMsg(response?.message);
              setShowSwalError(true);
              return; // Stop further processing
            }
          }
        } catch (error) {
          console.log("Error uploading file:", error);
          swal({
            title: "Error!",
            text: "An unexpected error occurred.",
            icon: "error",
            button: "OK",
          });
          return; // Stop further processing
        }
      }
    }
  
    // After all files are uploaded, make the final payload and API call
    const payload = {
      files: AttachFileIDs,
      user_id: userId,
    };
  
    try {
      const response = await post(POST_POStoreFiles, payload);
      if (response.status === 200) {
        swal({
          title: "Success",
          text: response?.message,
          icon: "success",
          button: "OK",
        });
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else {
        if (typeof response?.message == "string") {
          swal({
            title: "Error!",
            text: response.message,
            icon: "error",
            button: "OK",
          });
        } else {
          setSwalErrorMsg(response?.message);
          setShowSwalError(true);
        }
      }
    } catch (error) {
      console.log("Error storing files:", error);
      swal({
        title: "Error!",
        text: "An unexpected error occurred.",
        icon: "error",
        button: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleSimpleSubmit = async (values, { resetForm }) => {
    setIsLoading(true)
    try {
      const payload = {
        name: values.name,
        email: values.email,
        phone: values.contactNumber,
      }

      const response = await post(POST_CreatePOUploadVerification, payload)

      if (response.status === 200) {
        swal({
          title: "Success",
          text: response.message || "Contact created successfully!",
          icon: "success",
          button: "OK",
        }).then(() => {
          resetForm()
          navigate("/po-upload")
        })
      } else {
        if (typeof response.message === "string") {
          swal({
            title: "Error!",
            text: response.message,
            icon: "error",
            button: "OK",
          })
        } else {
          setSwalErrorMsg(response.message)
          setShowSwalError(true)
        }
      }
    } catch (error) {
      console.error("Error creating contact:", error)
      swal({
        title: "Error!",
        text: "An unexpected error occurred.",
        icon: "error",
        button: "OK",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const { handleSubmit, errors, touched } = formik

  // const handleFileUploadChange = (e, index) => {
  //   const updatedFields = [...attachFileFields]
  //   updatedFields[index].File = e.target.files[0]
  //   setAttachFileFields(updatedFields)
  // }

  const handleFileUploadChange = (e, index) => {
    const selectedFile = e.target.files[0];
  
    // Fetch max file size from .env file (default to 5MB if not set)
    const maxFileSizeMB = parseFloat(process.env.REACT_APP_IMAGE_SIZE_LIMIT) || 2; // Default to 5MB
  
    // Convert file size to MB
    const fileSizeInMB = Math.round(selectedFile.size / 1024 / 1024); // Convert bytes to MB
  
    // Check if file size exceeds the allowed limit
    if (fileSizeInMB > maxFileSizeMB) {
      e.target.value = null;  // Clear the input
      swal("Attach File(s)", `You can upload file upto ${maxFileSizeMB}MB size!`, "warning");
      return;  // Stop further processing
    }
  
    // If file size is valid, proceed to update the file field
    const updatedFields = [...attachFileFields];
    updatedFields[index].File = selectedFile;
    setAttachFileFields(updatedFields);
  };
  

  const handleAddMoreFiles = () => {
    setAttachFileFields([...attachFileFields, { File: "" }])
  }

  const handleRemoveFile = index => {
    const updatedFields = attachFileFields.filter((_, i) => i !== index)
    setAttachFileFields(updatedFields)
  }

  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>Add Contact | Katlax OMS</title>
          </MetaTags>

          <Container fluid>
            <Row className="mt-1">
              <Col lg={6}>
                <div className="mt-1" style={{ fontSize: "large" }}>
                  <b>Welcome to Katlax Enterprise Pvt Ltd.</b>
                </div>
                <div className="mt-1">
                  <p>
                    Please enter your name, email & contact number to upload
                    Purchase Order
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <FormikProvider value={formik}>
                      <Form onSubmit={handleSubmit}>
                        <Row className="mt-3">
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Name <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <Field
                              name="name"
                              type="text"
                              placeholder="Enter Name"
                              disabled={!!token}
                              component={CustomInput}
                            />
                            {/* {errors.name && touched.name && (
                              <div className="text-danger">{errors.name}</div>
                            )} */}
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Email <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <Field
                              name="email"
                              type="email"
                              placeholder="Enter Email"
                              disabled={!!token}
                              component={CustomInput}
                            />
                            {/* {errors.email && touched.email && (
                              <div className="text-danger">{errors.email}</div>
                            )} */}
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Contact Number{" "}
                              <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <Field
                              name="contactNumber"
                              type="text"
                              placeholder="Enter Contact Number"
                              disabled={!!token}
                              component={CustomInput}
                            />
                            {/* {errors.contactNumber && touched.contactNumber && (
                              <div className="text-danger">{errors.contactNumber}</div>
                            )} */}
                          </Col>
                        </Row>

                        {token && (
                          <>
                            {/* <hr /> */}
                            <Row className="mt-3">
                              <Col lg={2}>
                                <div
                                  className="mt-2"
                                  style={{ color: "#000000" }}
                                >
                                  Attach Document(s)
                                </div>
                                <p>
                                  (XLS/PDF/XML/CSV/JPG <br/>For any graphics file pls
                                  provide link the file in the your PO)
                                </p>
                              </Col>
                              <Col lg={5}>
                                {attachFileFields.map((field, index) => (
                                  <div key={index} className="d-flex mb-2">
                                    <input
                                      type="file"
                                      className="form-control"
                                      onChange={e =>
                                        handleFileUploadChange(e, index)
                                      }
                                    />
                                    &nbsp;
                                    <Button
                                      color="danger"
                                      onClick={() => handleRemoveFile(index)}
                                    >
                                      <i className="fas fa-times"></i>
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  color="secondary"
                                  onClick={handleAddMoreFiles}
                                >
                                  <i className="fas fa-plus-circle"></i> Add
                                  More
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )}

                        <hr />

                        <Row className="mt-3">
                          <Col lg={6}>
                            <button className="btn btn-primary" type="submit">
                              Submit
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => navigate("/login")}
                            >
                              Cancel
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <SwalError
              showError={showSwalError}
              setShowError={setShowSwalError}
              ErrorMsg={swalErrorMsg}
            />
          </Container>
        </div>
      </Spin>
    </React.Fragment>
  )
}

AddPOUploadVerification.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(AddPOUploadVerification))
